import clsx from 'clsx';
import { FC } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { ElementarySchoolLoader } from 'src/components/elementary-school-view/elementary-school-loader';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';

import './loading-screen.scss';

type Props = {
  isJoiningLesson?: boolean;
  isTransparentVersion?: boolean;
};

export const LoadingScreen: FC<Props> = ({
  isJoiningLesson = false,
  isTransparentVersion = false,
}) => {
  const { t } = useTranslation();
  const isMiddleSchoolView = useIsMiddleSchoolView();

  if (!isMiddleSchoolView && isJoiningLesson) {
    return <ElementarySchoolLoader text={t('Joining lesson')} />;
  }

  return createPortal(
    <div
      className={clsx('loading-screen', {
        'loading-screen__transparent': isTransparentVersion,
      })}
      data-testid="default-loading-screen"
    >
      <h3
        className="loading-screen__title"
        data-testid="default-loading-screen-title"
      >
        {t('Loading...')}
      </h3>
      <img
        className="loading-screen__image"
        src="https://learning.amplify.com/m/725e04cc46f1c9ee/original/sh-ms-loading-hamster.gif"
        alt="LoadingScreen"
      />
    </div>,
    document.body,
  );
};
